(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw--featured-collection"] && !Shopify.designMode) return;
  try {
    

  var swiper = new Swiper(".cs_product_Swiper", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: ".collection_product_block .swiper-button-next",
      prevEl: ".collection_product_block .swiper-button-prev",
    },
    breakpoints: {
      370: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw--our_collection"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".our_collections_Swiper", {
    slidesPerView: 2,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: ".our_collections_slider .swiper-button-next",
      prevEl: ".our_collections_slider .swiper-button-prev",
    },
    breakpoints: {
      426: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      600: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw--our_quality_values"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".quality_values_slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".our_values_slider_btn .swiper-button-next",
      prevEl: ".our_values_slider_btn .swiper-button-prev",
    },
    breakpoints: {
      426: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    on: {
      init: function () {
        toggleNavigationButtons(this);
      },
      resize: function () {
        toggleNavigationButtons(this);
      },
    },
  });

  function toggleNavigationButtons(swiperInstance) {
    const totalSlides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    const nextBtn = document.querySelector(".our_values_slider_btn .swiper-button-next");
    const prevBtn = document.querySelector(".our_values_slider_btn .swiper-button-prev");

    // Check if total slides are greater than visible slides
    if (totalSlides <= slidesPerView) {
      nextBtn.style.display = "none";
      prevBtn.style.display = "none";
    } else {
      nextBtn.style.display = "flex";
      prevBtn.style.display = "flex";
    }
  }

  } catch(e) { console.error(e); }
})();
})();
